<template>
  <div>
    <v-card class="pa-5 elevation-hb">
      <v-row align="center" justify="center">
        <v-col>
          <h3><v-icon large>mdi-store</v-icon> Sellers</h3>
        </v-col>
        <v-col cols="4">
          <TheSearchInput v-model="search" />
        </v-col>
      </v-row>

      <v-divider class="my-3"></v-divider>
      <v-data-table
        :headers="headers"
        :items="sellers"
        :search="search"
        :loading="loading"
        :footer-props="{
          'items-per-page-options': [15, 30, 60, -1],
          'items-per-page-text': 'Itens por Página',
        }"
      >
        <template v-slot:[`item.date`]="{ item }">
          {{ item.expirationDt | formatDate }}
        </template>
        <template v-slot:[`item.locale`]="{ item }">
          {{ item.city }} <span v-if="item.city && item.state">-</span>
          {{ item.state }}
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <TheToolTip label="Definir margem de preço do Seller" v-if="checkAcess(['admin', 'supplier'])">
            <v-icon @click="editPriceMargin(item)">mdi-margin</v-icon>
          </TheToolTip>
          <TheToolTip label="Editar Endereço">
            <v-btn small icon depressed :loading="loading">
              <v-icon class="ma-1" @click="editSellerAddress(item)">
                mdi-city-variant-outline
              </v-icon>
            </v-btn>
          </TheToolTip>

          <TheToolTip label="Ver Produtos">
            <v-btn small icon depressed :loading="loading">
              <v-icon class="ma-1" @click="productSeller(item)">
                mdi-archive
              </v-icon>
            </v-btn>
          </TheToolTip>

          <TheToolTip label="Ver Frete">
            <v-btn small icon depressed :loading="loading">
              <v-icon class="ma-1" @click="freightSeller(item)">
                mdi-truck-fast
              </v-icon>
            </v-btn>
          </TheToolTip>

          <TheToolTip label="Configurar"  v-if="checkAcess(['admin', 'supplier'])">
            <v-btn small icon depressed :loading="loading">
              <v-icon class="ma-1" @click="configureSeller(item)">
                mdi-cog
              </v-icon>
            </v-btn>
          </TheToolTip>

          <TheToolTip label="Atualizar Estoque"  v-if="checkAcess(['admin', 'supplier'])">
            <v-btn small icon depressed :loading="loading" v-if="item.integrationType === 'Bling'">
              <v-icon class="ma-1" @click="updateStock(item)">
                mdi-update
              </v-icon>
            </v-btn>
          </TheToolTip>
        </template>
      </v-data-table>
    </v-card>
    
    <TheDialog v-model="updateConfirmation" title="Aviso" width="400px">
      <template>
        <p class="text-center">
          A atualização de estoque está em andamento. Aguarde o final do processo.
        </p>
        <p class="text-center">
          <v-btn small depressed color="primary" class="mt-2" dark @click="updateConfirmation = false">Continuar</v-btn>
        </p>
      </template>
    </TheDialog>

    <TheDialog v-model="priceMarginDialog" title="Definição de Variação de Preço" width="800px" icon="mdi-margin">
      <template>
        <p>
          Variação de Preço para: <b>{{ object.sellerDescription }}</b
          >.
        </p>
        <v-divider class="my-3"></v-divider>
        <h3>Definição de Margem</h3>
        <v-range-slider color="success" v-model="range" :max="max" :min="min" hide-details class="align-center mb-10">
          <template v-slot:prepend>
            <v-text-field
              v-model="range[0]"
              class="mt-0 pt-0"
              single-line
              type="number"
              style="width: 60px"
              hint="(%)"
              persistent-hint
              @change="$set(object.range, 0, $event)"
            ></v-text-field>
          </template>
          <template v-slot:append>
            <v-text-field
              v-model="range[1]"
              class="mt-0 pt-0"
              single-line
              type="number"
              style="width: 60px"
              hint="(%)"
              persistent-hint
              @change="$set(object.range, 1, $event)"
            ></v-text-field>
          </template>
        </v-range-slider>
      </template>

      <template v-slot:actions>
        <v-spacer></v-spacer>
        <v-btn class="my-5" color="primary" @click="update(object)">
          <v-icon class="mr-1">mdi-content-save</v-icon>
          Salvar
        </v-btn>
      </template>
    </TheDialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mask } from 'vue-the-mask'
import { mapState } from 'vuex'
import { baseApiUrl, showError } from '@/global'
import TheDialog from '@/components/TheDialog'
import TheSearchInput from '@/components/TheSearchInput'
import TheToolTip from '@/components/TheToolTip'

export default {
  name: 'sellers',
  computed: mapState(['user','logged', 'permissions']),
  components: {
    TheSearchInput,
    TheToolTip,
    TheDialog,
  },
  directives: { mask },
  data: () => ({
    loading: false,
    dialog: false,
    updateConfirmation: false,
    priceMarginDialog: false,
    min: -100,
    max: 100,
    range: [0, 0],
    object: {},
    search: '',
    sellers: [],
    headers: [
      { text: 'ID', value: 'sellerId', width: '20%' },
      { text: 'Seller', value: 'sellerDescription', width: '20%' },
      { text: 'Integração', value: 'integrationType', width: '20%' },
      { text: 'Local', value: 'locale', width: '20%' },
      { text: 'Ações', value: 'action', sortable: false, align: 'left' },
    ],
  }),
  methods: {
    loadSellers() {
      this.loading = true
      const url = `${baseApiUrl}/seller`
      axios
        .get(url)
        .then((res) => {
          this.sellers = res.data
          this.loading = false
        })
        .catch(showError)
        .finally((this.loading = false))
    },
    updateStock(item) {
      this.loading = true
      this.updateConfirmation = true
      const url = `${baseApiUrl}/seller/${item.sellerId}/stock`
      axios
        .put(url)
        .then((res) => {
          // this.sellers = res.data
          this.loading = false
        })
        .catch(showError)
        .finally(() => {
          this.loading = false
        })
    },
    freightSeller(item) {
      this.$router.push({
        name: 'Sellers Freight',
        params: { id: item.sellerId },
      })
    },
    productSeller(item) {
      this.$router.push({
        name: 'Sellers Product',
        params: { id: item.sellerId },
      })
    },
    editSellerAddress(item) {
      this.$router.push({
        name: 'Sellers Address',
        params: { id: item.sellerId },
      })
    },
    configureSeller(item) {
      this.$router.push({
        name: 'Sellers Config',
        params: { id: item.sellerId },
      })
    },
    update(item) {
      const id = item.sellerId
      const object = {
        minPriceRange: this.range[0],
        maxPriceRange: this.range[1],
      }
      const url = `${baseApiUrl}/seller/${id}/price/range`
      axios
        .patch(url, object)
        .then(() => {
          this.priceMarginDialog = false
          this.range = [0, 0]
          this.$toasted.global.defaultSuccess()
          this.loadSellers()
        })
        .catch(showError)
    },
    editPriceMargin(item) {
      this.object = item
      this.range = [0, 0]
      if (item.minPriceRange && item.maxPriceRange) {
        this.range[0] = item.minPriceRange
        this.range[1] = item.maxPriceRange
      }
      this.priceMarginDialog = true
    },
    closeMargin() {
      this.object = []
      this.range = [0, 0]
    },
    checkAcess(groups) {
      return groups.find((group) => {
        return this.user.groups.includes(group)
      })
    },
  },
  mounted() {
    this.loadSellers()
  },
}
</script>
